/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ProductInputs */

const en_product = /** @type {(inputs: ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product`)
};

const es_product = /** @type {(inputs: ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producto`)
};

/**
* | output |
* | --- |
* | "Product" |
*
* @param {ProductInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const product = /** @type {((inputs?: ProductInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ProductInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_product(inputs)
	return es_product(inputs)
});